import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import CheckItem from '@propertypal/web-ui/src/inputs/CheckItem';
import React, { FunctionComponent } from 'react';
import { Container } from './IncludeExcludeInputs.style';

interface Props {
  filters: SearchState['filters'];
  isRental: boolean;
  handleFilterChange: UseSearchState['handleFilterChange'];
}

const IncludeExcludeInputs: FunctionComponent<Props> = ({ filters, handleFilterChange, isRental }) => {
  return (
    <Container>
      <CheckItem
        label={`Include ${isRental ? 'Let' : 'Sale'} agreed`}
        checked={filters.includeAgreed}
        onValueChange={handleFilterChange('includeAgreed')}
        testID="checkItem-includeSaleAgreed"
      />

      {filters.category === 'residential' && filters.saleType === 'rent' && (
        <CheckItem
          label="Exclude Student Lettings"
          checked={filters.excludeStudentLettings}
          onValueChange={handleFilterChange('excludeStudentLettings')}
          testID="checkItem-excludeStudentLettings"
        />
      )}

      {['residential', 'newhomes', 'student', 'holidayhomes'].includes(filters.category) &&
        filters.saleType === 'sale' && (
          <CheckItem
            label="Chain Free Properties"
            checked={(filters.tags && filters.tags.includes('chainFree')) || false}
            onValueChange={handleFilterChange('tags-chainFree')}
            testID="toggle-includeChainFree"
          />
        )}

      {((filters.category === 'residential' && filters.saleType === 'sale') || filters.category === 'newhomes') && (
        <CheckItem
          label="Suitable for Co-Ownership"
          checked={filters.coOwnership}
          onValueChange={handleFilterChange('coOwnership')}
          testID="checkItem-coown"
        />
      )}

      {filters.category === 'residential' && filters.saleType === 'sale' && (
        <CheckItem
          label="Exclude New Homes"
          checked={filters.excludeNewHomes}
          onValueChange={handleFilterChange('excludeNewHomes')}
          testID="checkItem-excludeNewHomes"
        />
      )}

      <CheckItem
        label="Exclude Price Not Provided"
        checked={filters.excludePoa}
        onValueChange={handleFilterChange('excludePoa')}
        testID="checkItem-excludePoa"
      />
    </Container>
  );
};

export default IncludeExcludeInputs;
